import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

function LikeButton() {
    this.defaultAttrs({
        currentLikeCount: '[data-like-count]',
    });

    this.getLikeCount = function() {
        return parseInt(this.select('currentLikeCount').text(), 10);
    };

    this.setLikeCount = function(count) {
        this.select('currentLikeCount').text(count);
    };

    this.isDesignLiked = function() {
        return this.$node.attr('data-liked') === 'true';
    };

    this.setDesignLiked = function(isLiked) {
        this.$node.attr('data-liked', `${isLiked}`);
    };

    this.setLikeStatusAndCount = function(isLiked, likeCount) {
        this.setDesignLiked(isLiked);
        this.setLikeCount(likeCount);
    };

    this.onDesignLikedSuccess = function(e, data) {
        this.setLikeStatusAndCount(true, data.likeCount);
    };

    this.onDesignUnlikedSuccess = function(e, data) {
        this.setLikeStatusAndCount(false, data.likeCount);
    };

    this.toggle = function(e) {
        e.preventDefault();
        if (this.isDesignLiked()) {
            this.setLikeStatusAndCount(false, this.getLikeCount() - 1);
            this.trigger(this.$node, 'uiDesignUnliked');
        } else {
            this.setLikeStatusAndCount(true, this.getLikeCount() + 1);
            this.trigger(this.$node, 'uiDesignLiked');
        }
    };

    this.after('initialize', function() {
        this.on(this.$node, 'dataDesignLikedSuccess', this.onDesignLikedSuccess);
        this.on(this.$node, 'dataDesignUnlikedSuccess', this.onDesignUnlikedSuccess);

        this.on('click', this.toggle);
    });
}

export default defineComponent(LikeButton);



// WEBPACK FOOTER //
// ./src/js/component_ui/like.js